import React, { useEffect, useState } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../../loader/CircleLoade";
import { Link } from "react-router-dom";
import Navbar from "../../../common/Navbar";

export default function SalesMakeWishHistory() {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [salesMakeWishHistory, setSalesMakeWishHistory] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [filterData, setFilterData] = useState('');
  const [changeStatus, setChangeStatus] = useState('');
  const [phoneNum , setPhoneNum] = useState('')

  useEffect(() => {
    getSalesMakeWishHistory(1);
  }, [changeStatus, phoneNum]);

  const searchFormik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.startDate === "" && data.endDate !== "") {
        errors.startDate = "Please select date";
      }
      if (data.startDate !== "" && data.endDate === "") {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getSalesMakeWishHistory(data, 1);
      setFilterData(data);
    },
  });
  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);
  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

  const getSalesMakeWishHistory = async (pageNum) => {
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
      const phoneFilter = filterData ? `&merchantId=${filterData}` : '';
      const changedStatus = changeStatus ? `&status=${changeStatus}` : '';
      // const numberFilter = phoneNum ? `&mobile=${phoneFilter}` : '';
      const phoneOrMerchant = phoneNum ? 
      (/^\d+$/.test(phoneNum) ? `&mobile=${phoneNum}` : `&merchantId=${phoneNum}`) 
      : '';
        const data = await axios
        .get(
          Constants.baseUrl +
            `reports/makeWish/list?sortBy=createdDateTime&sortAsc=true&limit=10&page=1${phoneOrMerchant}${changedStatus}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program2,
            },
          }
        )
        .then((res) => {
          //console.log(res);
          const dt = res.data;
          if (dt.result === "success") {
            setSalesMakeWishHistory(dt?.output?.results);
            setTotalPages(dt?.output?.totalPages);
            setLoading(false);
            setSalesMakeWishHistory(data)
          }
          if (dt.result === "error" || dt.result === "dialog") {
            setSalesMakeWishHistory(null);
            setTotalPages(0);
            setLoading(false);
          }
    // console.log("data...",data)
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const areAllValuesBlank = () => {
    const { startDate, endDate } = searchFormik.values;
    return !startDate && !endDate;
  };

  return (
    <>
      {loading ? <Oval /> : null}
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h3 className="head2">Make a Wish History</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  {/* <strong className="card-title">Existing Retailers</strong> */}
                </div>
                <div className="card-body">
                  <div className="row">
										<div className="col-md-3 col-xs-6 text-right">
											<div className="form-group">
												<input className="form-control" type="text" placeholder="Search Retailers"
                         value={phoneNum} onChange={(e)=> setPhoneNum(e.target.value)}/>
											</div>
										</div>
                    <button className="btn btn-primary" onClick={getSalesMakeWishHistory}>Search</button>
                    <select class="form-select" style={{marginLeft:"10px", padding:"5px"}} value={changeStatus} 
                    onChange={(e)=>setChangeStatus(e.target.value)}>
                      <option value="">All</option>
                      <option value="APPROVED">APPROVED</option>
                      <option value="PENDING">PENDING</option>  
                      <option value="REJECT">REJECT</option>  
                    </select>
									</div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive table--no-card">
                        <table className="table table-borderless table-striped table-earning">
                          <thead>
                            <tr>
                              <th> S No. </th>
                              <th> Date </th>
                              <th> Retailer Id </th>
                              <th> Name </th>
                              <th> Mobile </th>
                              <th> Description </th>
                              <th> Status </th>
                            </tr>
                          </thead>
                          {salesMakeWishHistory === null ? (
                            <tbody>
                              <tr>
                                <td
                                  colSpan="5"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "16px",
                                  }}
                                >
                                  No record found!
                                </td>
                              </tr>
                            </tbody>
                          ) : (
                            <tbody>
                              {salesMakeWishHistory &&
                                salesMakeWishHistory.length > 0 &&
                                salesMakeWishHistory.map((row, index) => {
                                  const serialNumber =
                                    (currentPage - 1) * limit + index + 1;

                                  const createdDate = row.createdDateTime
                                    ? moment(row.createdDateTime).format(
                                        "DD-MM-YYYY"
                                      )
                                    : "";
                                  return (
                                    <>
                                      <tr key={index}>
                                        <td>{serialNumber}</td>
                                        <td>{row[1]}</td>
                                        <td>{row[2]}</td>
                                        <td>{row[3]}</td>
                                        <td>{row[4]}</td>
                                        <td>{row[5]}</td>
                                        <td>{row[6]}</td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          )}
                        </table>
                        {totalPages > 1 && (
                          <ResponsivePagination
                            current={currentPage}
                            total={totalPages}
                            onPageChange={(page) => {
                              setCurrentPage(page);
                              getSalesMakeWishHistory(page);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
